import { Component, Input, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.sass']
})
export class OrderSummaryComponent implements OnInit {
  @Input() itemsCart:any=[];
  public councilTaxes:number=0;
  public numberOfElements:number=0;
  public stateTaxes:number=0;
  public deposit:number=0;
  public load:boolean=false;
  constructor(public global: GlobalService) { }
  ngOnInit() {
    this.load=true
  }
  ngOnChanges(){
    this.councilTaxes=this.itemsCart.taxes[0].taxAmt;
    this.stateTaxes=this.itemsCart.taxes[1].taxAmt;
    if(this.itemsCart.taxes[0].taxAmt<=0){
      this.councilTaxes=0;
    }
    if(this.itemsCart.taxes[1].taxAmt<=0){
      this.stateTaxes=0;
    }
  }
}
